import { render } from "./EventWelcomeOverlay.vue?vue&type=template&id=5fd59cd8&scoped=true"
import script from "./EventWelcomeOverlay.vue?vue&type=script&lang=js"
export * from "./EventWelcomeOverlay.vue?vue&type=script&lang=js"

import "./EventWelcomeOverlay.vue?vue&type=style&index=0&id=5fd59cd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd59cd8"]])

export default __exports__